<template>
  <div class="flex flex-col pl-2">
    <div class="relative">
      <h2 class="p-2 text-center text-6pt font-bold capitalize">
        {{ $t("legal_text.toc") }}
      </h2>
      <div class="absolute right-0 top-1.5 flex items-center gap-1">
        <LegalTextTocExpandButton
          :openState
          @click="openState === 'open' ? closeAllTabs() : openAll()"
        />
      </div>
    </div>
    <ul ref="legalTextTocSub" class="list-none overflow-y-auto pb-4 pr-3">
      <li
        v-for="legalText in toc"
        :key="legalText.id"
        class="my-1"
        @click="toggleCollapse"
        @keyup.enter="toggleCollapse"
      >
        <LegalTextDisclosure
          :legalTextSlug="legalTextSlug"
          :legalTextToc="legalText"
          :tocOverviewParagraph="lastOpenedParagraph"
          :parentsOfActiveParagraph="parentsOfOpenedParagraph"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { IToC } from "~/models/IToC";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

const props = defineProps<{
  toc: IToC[];
  flatToc: (IToC | ILegalTextParagraph)[];
  legalTextSlug: string;
  tocOverviewParagraph?: ILegalTextParagraph;
}>();

const legalTextTocSub = ref();

const lastOpenedParagraph = ref(props.tocOverviewParagraph);

const closeAllTabs = () => {
  lastOpenedParagraph.value = undefined;
  closeAll();
};

const { closeAll, openAll, toggleCollapse, openState } = useLegalTextDisclosure(
  legalTextTocSub,
  !!props.tocOverviewParagraph
);

const parentsOfOpenedParagraph = computed(() =>
  parentsOfParagraph(props.flatToc, props.tocOverviewParagraph?.slug)
);
</script>
